// Module
var code = "<div class=\"card borderless-card pb-2\"> <p>No results</p> </div>";
// Exports
export default code;